import { render, staticRenderFns } from "./dishesTable.vue?vue&type=template&id=6506d6d8&scoped=true&"
import script from "./dishesTable.vue?vue&type=script&lang=js&"
export * from "./dishesTable.vue?vue&type=script&lang=js&"
import style0 from "./dishesTable.vue?vue&type=style&index=0&id=6506d6d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506d6d8",
  null
  
)

export default component.exports